import { render, staticRenderFns } from "./IPRecords.vue?vue&type=template&id=054665b4&scoped=true"
import script from "./IPRecords.vue?vue&type=script&lang=js"
export * from "./IPRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054665b4",
  null
  
)

export default component.exports